import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';

export default function SpamDashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/security?tab=spam', { replace: true });
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <RefreshCw className="h-12 w-12 animate-spin text-blue-600 mx-auto mb-4" />
        <p className="text-muted-foreground dark:text-muted-foreground/60">Reindirizzamento al Security Center...</p>
      </div>
    </div>
  );
}
